import { createVuetify } from 'vuetify';
import 'vuetify/styles';
import '@mdi/font/css/materialdesignicons.css';
import '@mdi/font/css/materialdesignicons.min.css';
import { vuetifyOptions } from '@ilteducation/themes/manabua/vuetifyOptions';

const vuetify = createVuetify(vuetifyOptions);

export default vuetify;
